import { Observable, Subject } from 'rxjs';

export default class SubscriptionService {
    constructor($http, host){
        this.http = $http;
        this.host = host;

        this._paymentStatus$ = new Subject();
        this._graceNoticeWasDisplayed = false;
    }

    updatePaymentStatus(newStatus) { this._paymentStatus$.next(newStatus); }
    paymentStatus() { return this._paymentStatus$; }

    setGraceNoticeDisplayed() { this._graceNoticeWasDisplayed = true; }
    wasGraceNoticeDisplayed() { return this._graceNoticeWasDisplayed; }

    subscribeCustomerViaStripe(data){
        return Observable.fromPromise(this.http({
           method: 'POST',
           url: `${this.host}/api/accounts/subscription`,
           data: data
        }).then((resp) => { 
            return resp.data;
        }));
    }
    // unsubscribe() {
    //     return Observable.fromPromise(this.http({
    //         method: 'DELETE', url: `${this.host}/api/accounts/subscription`
    //      }));
    // }

    addPaymentMethod(data) {
        return Observable.fromPromise(this.http({
            method: 'POST',
            url: `${this.host}/api/accounts/payment-methods`,
            data: data
         }).then((resp) => { 
             return resp.data;
         }));
    }
    deletePaymentMethod(token) {
        return Observable.fromPromise(this.http({
            method: 'DELETE',
            url: `${this.host}/api/accounts/payment-methods/${token}`
         }));
    }
    setDefaultPaymentMethod(token) {
        return Observable.fromPromise(this.http({
            method: 'PATCH',
            url: `${this.host}/api/accounts/payment-methods/${token}`
         }));
    }
    getCustomerCards(){
        return Observable.fromPromise(this.http({
            method: 'GET',
            url: `${this.host}/api/accounts/payment-methods`, 
        }).then((resp) => {
            return resp.data;
        }).catch((resp) => {
            return resp;
        }));
    }

}

SubscriptionService.$inject = ['$http', 'host'];


// WEBPACK FOOTER //
// ./src/app/services/subscribe.service.js